import type { FaireProductEntity } from "../../entity_types/product";

export const p_n83442wbwf: FaireProductEntity = {
  token: "p_n83442wbwf",
  type: "product",
  name: "Bulk Pack - The New Kid",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/657287ea695d83fc89dd189f801adbff77f5968a7cf4599449e0bf20b7beee89.png",
  galleryImageUrls: [],
  priceDollars: 427,
  description:
    "\nLooking to start your own snacking business or add some unique and hard-to-find items to your store? Our online starter pack special is the perfect way to get started. This package includes a curated selection of 300 of our most popular snacks and drinks, all carefully sourced from around the world. From artisanal chocolates to unique and exotic sodas, these items are sure to satisfy even the most selective customers. With fast and reliable shipping, you can stock your shelves with the world's most sought-after treats in no time. Order your online starter pack special today and take your snacking business to the next level!\n\nEXAMPLE OF BREAKDOWN:\nSample shown (61 items total):\n10 Chips \n10 Gummy Candies \n8 Chocolate Bars \n7 Sodas/Beverages \n22 Cookies and/or Wafers \n1 mixed boxed of lollipops\n\n*Items subject to change in every package based on newest rare and limited snacks and best stock.\n\n",
  tags: [],
  msrpDollars: 854,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:02.705Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
